import { createContext } from "react";
import { ConsoleAnalytics } from "../providers/ConsoleAnalytics";
import type { Analytics } from "./Analytics";
import type { BaseEvent } from "./BaseEvent";

export const AnalyticsContext = createContext<Analytics<BaseEvent<object>>>(
  new ConsoleAnalytics()
);
